import { DeleteSquareXButton } from 'assets/images/components/NudosComponents';
import { useEffect, useState } from 'react';
import './UploadErrors.scss';

interface UploadErrorsProps {
  errors: string[];
}

const UploadErrors = ({ errors }: UploadErrorsProps) => {
  const [errorsList, setErrorsList] = useState<string[]>([]);

  useEffect(() => {
    const errorsClean = errors.map(error => error.replace(/\s?❌\s?/, ''));
    setErrorsList(errorsClean);
  }, [errors]);

  return (
    <div className="uploadErrors">
      {errorsList.map(error => (
        <div className="uploadErrorsItem" key={`error-${error}`}>
          <DeleteSquareXButton className="deleteErrorIcon" />
          <p>{error}</p>
        </div>
      ))}
    </div>
  );
};

export default UploadErrors;
